import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {entityDocumentosFeatureKey, reducer} from './entity-documento.reducer';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(entityDocumentosFeatureKey, reducer),
  ],
})
export class EntityDocumentoModule {
}
